module.exports = __webpack_public_path__ + "932d3c09f5bde7e13115c0ddcadeb44f.svg";